import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Input, Output, Inject, NgModule } from '@angular/core';
import { BehaviorSubject, of, Observable } from 'rxjs';
import * as i3 from '@cnaf/ng-cnaf-commons';
import { NgCnafCommonsModule } from '@cnaf/ng-cnaf-commons';
import * as i1 from '@angular/forms';
import { FormControl, Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'ngx-bootstrap/typeahead';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { switchMap, map, tap } from 'rxjs/operators';

class CcdBarreNavigationService {
    /**
    * Libelles de la barre d'étape
    */
    libellesEtapes;
    /**
     * Position courante dans la barre d'étape (index du tableau de libellé)
     */
    positionCourante;
    /**
     * libelle de l'étape courante qui change en fonction des appels "passerEtapeSuivante" et "passerEtapePrecedente"
     */
    libelleEtapeCourante = new BehaviorSubject("");
    libelleEtapeCourante$ = this.libelleEtapeCourante.asObservable();
    /**
     * Constructeur
     */
    constructor() {
        this.libellesEtapes = [];
        this.positionCourante = 0;
    }
    /**
     * Initialisation de la barre d'étapes
     * @param _libellesEtapes tableau de string qui contient les libellés de chaque étape du bandeau
     */
    init(_libellesEtapes) {
        this.libellesEtapes = _libellesEtapes;
    }
    /**
     * Détermine le libelle de l'étape en cours en fonction de l'index et le tableau des libellés
     * @param position index (nombre positif)
     * @param tableauLibelles (tableau de string)
     */
    determinerLibelleEtapeCourante(_position, _tableauLibelles) {
        return _tableauLibelles[_position];
    }
    /**
     * Donne l'observable qui indique le libellé de l'étape courante, utilisé par la barre d'étape
     */
    getLibelleEtapeCourante$() {
        return this.libelleEtapeCourante$;
    }
    /**
     * Donne le tableau des libellés de la barre d'étape
     */
    getLibellesEtapes() {
        let result = this.libellesEtapes;
        if (!result) {
            result = new Array();
        }
        return result;
    }
    /**
     * Passe à l'étape suivante
     * Pour changer d'étape, il est possible aussi d'appeler appliquerEtapeActive
     */
    passerEtapeSuivante() {
        if (this.positionCourante !== undefined) {
            this.positionCourante++;
            const nouveauLibEtEtape = this.determinerLibelleEtapeCourante(this.positionCourante, this.libellesEtapes);
            this.libelleEtapeCourante.next(nouveauLibEtEtape);
        }
    }
    /**
     * Revient à l'étape précédente
     * Pour changer d'étape, il est possible aussi d'appeler appliquerEtapeActive
     */
    passerEtapePrecedente() {
        if (this.positionCourante !== undefined) {
            this.positionCourante--;
            const nouveauLibEtEtape = this.determinerLibelleEtapeCourante(this.positionCourante, this.libellesEtapes);
            this.libelleEtapeCourante.next(nouveauLibEtEtape);
        }
    }
    /**
     * Passe à l'étape assocée au string passé en paramètre.
     * Pour changer d'étape, il est possible aussi d'appeler passerEtapeSuivante / passerEtapePrecedente
     * @param _libelleEtape string
     */
    appliquerEtapeActive(_libelleEtape) {
        if (_libelleEtape !== undefined && _libelleEtape.length > 0 && this.libellesEtapes !== undefined) {
            this.positionCourante = this.libellesEtapes.indexOf(_libelleEtape);
            this.libelleEtapeCourante.next(_libelleEtape);
        }
    }
    /**
     * Passe à l'étape assocée à l'index passé en paramètre
     * @param _index index dans la liste des étapes du bandeau
     */
    appliquerEtapeActiveAPartirIndex(_index) {
        this.positionCourante = _index;
        const libEtape = this.determinerLibelleEtapeCourante(this.positionCourante, this.libellesEtapes);
        this.libelleEtapeCourante.next(libEtape);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreNavigationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreNavigationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class CnafCommonsDralComponent {
    constructor() { }
    ngOnInit() {
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CnafCommonsDralComponent, selector: "lib-cnaf-commons-dral", ngImport: i0, template: `
    <p>
      cnaf-commons-dral works!
    </p>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-cnaf-commons-dral', template: `
    <p>
      cnaf-commons-dral works!
    </p>
  ` }]
        }], ctorParameters: () => [] });

class CcdBoutonsRadioComponent {
    controlContainer;
    cd;
    name = "default_name";
    id = "";
    libelle = "";
    idPopup = "";
    colMd = "col-md-2";
    informationsComplementaires = "";
    configurationBoutons = new Array();
    clickPopupEvent = new EventEmitter();
    _valeur = undefined;
    set valeur(valeur) {
        this._valeur = valeur;
        this.updateValue();
    }
    get valeur() {
        return this._valeur;
    }
    _disabled = false;
    set disabled(isDisabled) {
        this._disabled = isDisabled;
        this.updateDisabled();
    }
    dataChange = new EventEmitter();
    boutonRadioForm;
    subscriber;
    constructor(controlContainer, cd) {
        this.controlContainer = controlContainer;
        this.cd = cd;
        this.boutonRadioForm = new FormControl('', { nonNullable: true, validators: Validators.required });
    }
    ngOnInit() {
        if (this.id === '') {
            this.id = this.name;
        }
        const parentForm = this.controlContainer?.control;
        this.boutonRadioForm = new FormControl(this._valeur, { nonNullable: true, validators: Validators.required });
        parentForm.addControl(this.name, this.boutonRadioForm);
        this.updateDisabled();
        this.subscriber = this.boutonRadioForm.valueChanges.subscribe(data => {
            this._valeur = data;
            this.dataChange.emit(this._valeur);
        });
    }
    ngAfterContentChecked() {
        this.cd.detectChanges();
    }
    updateValue() {
        this.boutonRadioForm.patchValue(this._valeur);
    }
    /**
     * A la destruction du composant :
     * Suppression des listeners
     * Suppression du FormControl dans le parent pour eviter des erreurs de validation
     * Emmit de la valeur à vide (pour que le parent ne garde pas l'ancienne valeur)
     */
    ngOnDestroy() {
        //setTimeout(() => {
        const parentForm = this.controlContainer.control;
        parentForm.removeControl(this.name);
        //});
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
        this.dataChange.emit(undefined);
    }
    updateDisabled() {
        if (this._disabled) {
            this.boutonRadioForm.disable();
        }
        else {
            this.boutonRadioForm.enable();
        }
    }
    clickEmitEventPopup($event) {
        this.clickPopupEvent.emit($event);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBoutonsRadioComponent, deps: [{ token: i1.ControlContainer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdBoutonsRadioComponent, selector: "ccd-boutons-radio", inputs: { name: "name", id: "id", libelle: "libelle", idPopup: "idPopup", colMd: "colMd", informationsComplementaires: "informationsComplementaires", configurationBoutons: "configurationBoutons", valeur: "valeur", disabled: "disabled" }, outputs: { clickPopupEvent: "clickPopupEvent", dataChange: "dataChange" }, ngImport: i0, template: "<div class=\"row\">\r\n    <div class=\"col-sm-12 form-group\">\r\n\r\n        <fieldset>\r\n            <legend class=\"label-form-cnaf\" attr.for=\"{{id}}\" *ngIf=\"libelle!=''\">\r\n                {{libelle}}\r\n                <span>\r\n                    <ng-cnaf-aide \r\n                        *ngIf=\"idPopup\" \r\n                        idDiv=\"{{idPopup}}\" \r\n                        alt=\"{{informationsComplementaires}}\" \r\n                        data-container=\"body\"\r\n                        (click)=\"clickEmitEventPopup(idPopup)\">\r\n                    </ng-cnaf-aide>\r\n                </span>\r\n            </legend>\r\n\r\n            <!-- <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup class=\"form-group w-100\" > \r\n                    col-4 col-md-4\r\n                     <div class=\"btn-group col-6 col-md-4 col-sm-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\"> \r\n                        <div class=\"btn-group col-4 col-md-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">\r\n                        <label class=\"h-100 d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel >                            \r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\" ngCnafButton ngCnafMessageErreur/>\r\n                            <span>{{bouton.libelle}}</span>                            \r\n                        </label>      \r\n                    </div>\r\n                </div>\r\n            </div> -->\r\n\r\n            <!-- <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup\r\n                    class=\"form-group btn-group d-flex flex-row align-items-center flex-wrap\">\r\n                    <div class=\"col-4 {{colMd}} ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">\r\n                        <label class=\"d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel>\r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\"\r\n                                ngCnafButton ngCnafMessageErreur />\r\n                            <span>{{bouton.libelle}}</span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div> -->\r\n\r\n            <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup\r\n                    class=\"form-group btn-group d-flex flex-row align-items-center flex-wrap\">\r\n                    <div class=\"col-12 col-md-4 col-sm-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">                        \r\n                        <label class=\"h-100 d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel>\r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\"\r\n                                ngCnafButton ngCnafMessageErreur />\r\n                            <span>{{bouton.libelle}}</span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            \r\n            </div>\r\n\r\n         \r\n\r\n        </fieldset>\r\n        \r\n    </div>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3.NgCnafAideComponent, selector: "ng-cnaf-aide", inputs: ["idDiv", "alt", "imgSrcHide", "imgSrcShow"], outputs: ["onOpen"] }, { kind: "directive", type: i3.NgCnafMessageErreurDirective, selector: "[formControlName],[formControl]", inputs: ["ngCnafMessageErreur", "controlName", "showError"] }, { kind: "directive", type: i3.NgCnafRadio, selector: "[ngCnafButton][type=radio]", inputs: ["name", "value", "disabled"] }, { kind: "directive", type: i3.NgCnafRadioGroup, selector: "[ngCnafRadioGroup]", inputs: ["name"] }, { kind: "directive", type: i3.NgCnafButtonLabel, selector: "[ngCnafButtonLabel]" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBoutonsRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-boutons-radio', template: "<div class=\"row\">\r\n    <div class=\"col-sm-12 form-group\">\r\n\r\n        <fieldset>\r\n            <legend class=\"label-form-cnaf\" attr.for=\"{{id}}\" *ngIf=\"libelle!=''\">\r\n                {{libelle}}\r\n                <span>\r\n                    <ng-cnaf-aide \r\n                        *ngIf=\"idPopup\" \r\n                        idDiv=\"{{idPopup}}\" \r\n                        alt=\"{{informationsComplementaires}}\" \r\n                        data-container=\"body\"\r\n                        (click)=\"clickEmitEventPopup(idPopup)\">\r\n                    </ng-cnaf-aide>\r\n                </span>\r\n            </legend>\r\n\r\n            <!-- <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup class=\"form-group w-100\" > \r\n                    col-4 col-md-4\r\n                     <div class=\"btn-group col-6 col-md-4 col-sm-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\"> \r\n                        <div class=\"btn-group col-4 col-md-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">\r\n                        <label class=\"h-100 d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel >                            \r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\" ngCnafButton ngCnafMessageErreur/>\r\n                            <span>{{bouton.libelle}}</span>                            \r\n                        </label>      \r\n                    </div>\r\n                </div>\r\n            </div> -->\r\n\r\n            <!-- <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup\r\n                    class=\"form-group btn-group d-flex flex-row align-items-center flex-wrap\">\r\n                    <div class=\"col-4 {{colMd}} ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">\r\n                        <label class=\"d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel>\r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\"\r\n                                ngCnafButton ngCnafMessageErreur />\r\n                            <span>{{bouton.libelle}}</span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div> -->\r\n\r\n            <div class=\"row\">\r\n                <div [formControl]=\"boutonRadioForm\" ngCnafRadioGroup\r\n                    class=\"form-group btn-group d-flex flex-row align-items-center flex-wrap\">\r\n                    <div class=\"col-12 col-md-4 col-sm-4 ajust-radio-button\" *ngFor=\"let bouton of configurationBoutons\">                        \r\n                        <label class=\"h-100 d-flex btn btn-default align-items-center justify-content-center\" ngCnafButtonLabel>\r\n                            <input id=\"{{id}}_{{bouton.code}}\" type=\"radio\" value=\"{{bouton.code}}\" class=\"visually-hidden\"\r\n                                ngCnafButton ngCnafMessageErreur />\r\n                            <span>{{bouton.libelle}}</span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            \r\n            </div>\r\n\r\n         \r\n\r\n        </fieldset>\r\n        \r\n    </div>\r\n</div>" }]
        }], ctorParameters: () => [{ type: i1.ControlContainer }, { type: i0.ChangeDetectorRef }], propDecorators: { name: [{
                type: Input
            }], id: [{
                type: Input
            }], libelle: [{
                type: Input
            }], idPopup: [{
                type: Input
            }], colMd: [{
                type: Input
            }], informationsComplementaires: [{
                type: Input
            }], configurationBoutons: [{
                type: Input
            }], clickPopupEvent: [{
                type: Output
            }], valeur: [{
                type: Input
            }], disabled: [{
                type: Input
            }], dataChange: [{
                type: Output
            }] } });

class CcdBarreProgressionComponent {
    message = "Chargement en cours...";
    constructor() { }
    ngOnInit() {
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreProgressionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdBarreProgressionComponent, selector: "ccd-barre-progression", inputs: { message: "message" }, ngImport: i0, template: "<div class=\"col-sm-12 center-middle-block\" class=\"text-center\">\r\n    <div class=\"progress\">\r\n        <div class=\"progress-bar progress-bar-info progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:100%\">\r\n            {{message}}\r\n        </div>\r\n    </div>\r\n</div>\r\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreProgressionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-barre-progression', template: "<div class=\"col-sm-12 center-middle-block\" class=\"text-center\">\r\n    <div class=\"progress\">\r\n        <div class=\"progress-bar progress-bar-info progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:100%\">\r\n            {{message}}\r\n        </div>\r\n    </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { message: [{
                type: Input
            }] } });

class MontantForm {
    montantFormControl = new FormControl('', []);
}
/**
 * Composant montant : <br>
 * Affiche un montant et son libellé associé (si celui-ci est défini).
 * Le paramètre name est obligatoire et est utilisé pour créer un formControl avec ce nom avec également les ID HTML générés pour gérer correctement l'accessibilité
 * Il est possible de récupérer le formControl de ce composant à partir du parent qui l'a injecté en fonction du paramètre name (pour savoir par exemple si le composant est en erreur)
 * Il est possible de donner une valeur à ce composant avec le paramètre value
 * Il est possible de detecter les changement de valeurs avec l'évènement output dataChange, à chaque évènement, le paramètre value est également mis à jour
 * Il est possible de passer des validators avec les messages d'erreurs associés spécifique.
 * Si les parametre validators et mapMessagesErreur ne sont pas définis, le composant applique le controle par défaut (champ obligatoire et pattern de type numérique).
 * Il est possible de mettre le composant en lecture seule en utilisant le parametre disabled
 * Lorsque le composant est détruit (si par exemple caché), il est automatiquement enlevé du formGroup du parent, afin d'eviter les problemes de remontées d'erreurs incohérentes
 */
class CcdMontantComponent {
    controlContainer;
    cd;
    montantFormControl = new FormControl('', { nonNullable: true });
    /**
     * Nom du composant (utilisé pour le formcontrol et les ID HTML)
     */
    name = "default_name";
    /**
     * Id composant
     */
    id = "";
    /**
     * Libellé associé au montant (optionnel)
     */
    libelle = "";
    /**
     * Valeur du montant (optionnel), si ce paramètre est renseigné, le composant affiche cette valeur
     */
    set value(value) {
        this._value = value;
        this.montantFormControl.patchValue(this._value);
    }
    get value() {
        return this._value;
    }
    _value = "";
    /**
     * Paramètre (optionnel) qui permet de définir une aide contextuelle dans le champ montant
     */
    placeHolder = "";
    /**
     * Paramètre qui permet d'utiliser des validators spécifiques pour le controle du montant.
     * Les messages d'erreur associés sont définis dans le paramètre mapMessagesErreur
     */
    _validators = undefined;
    set validators(validators) {
        this._validators = validators;
        this.updateValidators();
    }
    /**
     * Paramètre qui permet de mettre en lecture seule le montant
     */
    set disabled(isDisabled) {
        this._disabled = isDisabled;
        this.updateDisabled();
    }
    bulleAideDivId;
    bulleAideAlt;
    maxlength = "9";
    _disabled = false;
    /**
     * Paramètre qui permet de définir les messages d'erreur à afficher en fonction des validators
     */
    set mapMessagesErreur(mapErr) {
        this._mapMessagesErreur = mapErr;
    }
    get mapMessagesErreur() {
        return this._mapMessagesErreur;
    }
    _mapMessagesErreur = undefined;
    dataChange = new EventEmitter();
    subscriber;
    constructor(controlContainer, cd) {
        this.controlContainer = controlContainer;
        this.cd = cd;
    }
    /**
     * Initialisation du composant :
     * Application des validateurs et messages d'erreur par défaut si non renseignés
     * Récupération du formGroup parent et ajout du formControl associé au composant avec le nom passé en paramètre
     * Mise en place du listener pour les changement de valeurs dans le composant
     */
    ngOnInit() {
        if (this.id === '') {
            this.id = this.name;
        }
        if (this._validators == undefined) {
            this._validators = [Validators.required, Validators.pattern("^([1-9][0-9]*)$")];
        }
        if (this._mapMessagesErreur == undefined) {
            this._mapMessagesErreur = new Map();
            this._mapMessagesErreur.set("required", "Champ obligatoire");
            this._mapMessagesErreur.set("pattern", "Ce montant doit être un nombre entier");
        }
        const parentForm = this.controlContainer?.control;
        this.montantFormControl = new FormControl(this._value, { nonNullable: true, validators: this._validators });
        parentForm.addControl(this.name, this.montantFormControl);
        this.updateDisabled();
        this.subscriber = this.montantFormControl.valueChanges.subscribe(data => {
            this._value = data;
            this.dataChange.emit(this._value);
        });
    }
    ngAfterContentChecked() {
        this.cd.detectChanges();
    }
    ngOnDestroy() {
        this._value = "";
        this.dataChange.emit(this._value);
        const parentForm = this.controlContainer.control;
        parentForm.removeControl(this.name);
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    }
    updateDisabled() {
        if (this._disabled) {
            this.montantFormControl.disable();
        }
        else {
            this.montantFormControl.enable();
        }
    }
    updateValidators() {
        this.montantFormControl.clearValidators();
        this.montantFormControl.setValidators(this._validators);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdMontantComponent, deps: [{ token: i1.ControlContainer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdMontantComponent, selector: "ccd-montant", inputs: { name: "name", id: "id", libelle: "libelle", value: "value", placeHolder: "placeHolder", validators: "validators", disabled: "disabled", bulleAideDivId: "bulleAideDivId", bulleAideAlt: "bulleAideAlt", maxlength: "maxlength", mapMessagesErreur: "mapMessagesErreur" }, outputs: { dataChange: "dataChange" }, ngImport: i0, template: "<div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n        <label *ngIf=\"libelle\" class=\"label-form-cnaf control-label\" for=\"{{id}}\">{{libelle}}</label>\r\n        <div class=\"row cnaf-slide-toggle\">\r\n            <div class=\"col-12 col-sm-6 col-md-4\">\r\n                \r\n                <div class=\"form-group input-group\" \r\n                    [ngClass]=\"{'has-error': montantFormControl.invalid && (montantFormControl.touched || !montantFormControl.pristine) }\">\r\n\r\n                            <input type=\"text\" \r\n                                [name]=\"id\" \r\n                                [formControl]=\"montantFormControl\"\r\n                                [id]=\"id\" \r\n                                class=\"form-control input-group-end-cnaf w-75\"\r\n                                [placeholder]=\"placeHolder\">\r\n                            <span class=\"picto picto-euro input-group-text\"></span>\r\n\r\n                    <div class=\"has-error\"  *ngFor=\"let erreur of mapMessagesErreur | keyvalue\">\r\n                        <div class=\"help-block\"\r\n                            role=\"alert\"\r\n                             *ngIf=\"montantFormControl.hasError(erreur.key) && (montantFormControl.touched || !montantFormControl.pristine)\"\r\n                            tabindex=\"0\" >\r\n                            <p>{{erreur.value}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgCnafMessageErreurDirective, selector: "[formControlName],[formControl]", inputs: ["ngCnafMessageErreur", "controlName", "showError"] }, { kind: "pipe", type: i2.KeyValuePipe, name: "keyvalue" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdMontantComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-montant', template: "<div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n        <label *ngIf=\"libelle\" class=\"label-form-cnaf control-label\" for=\"{{id}}\">{{libelle}}</label>\r\n        <div class=\"row cnaf-slide-toggle\">\r\n            <div class=\"col-12 col-sm-6 col-md-4\">\r\n                \r\n                <div class=\"form-group input-group\" \r\n                    [ngClass]=\"{'has-error': montantFormControl.invalid && (montantFormControl.touched || !montantFormControl.pristine) }\">\r\n\r\n                            <input type=\"text\" \r\n                                [name]=\"id\" \r\n                                [formControl]=\"montantFormControl\"\r\n                                [id]=\"id\" \r\n                                class=\"form-control input-group-end-cnaf w-75\"\r\n                                [placeholder]=\"placeHolder\">\r\n                            <span class=\"picto picto-euro input-group-text\"></span>\r\n\r\n                    <div class=\"has-error\"  *ngFor=\"let erreur of mapMessagesErreur | keyvalue\">\r\n                        <div class=\"help-block\"\r\n                            role=\"alert\"\r\n                             *ngIf=\"montantFormControl.hasError(erreur.key) && (montantFormControl.touched || !montantFormControl.pristine)\"\r\n                            tabindex=\"0\" >\r\n                            <p>{{erreur.value}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1.ControlContainer }, { type: i0.ChangeDetectorRef }], propDecorators: { name: [{
                type: Input
            }], id: [{
                type: Input
            }], libelle: [{
                type: Input
            }], value: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], validators: [{
                type: Input
            }], disabled: [{
                type: Input
            }], bulleAideDivId: [{
                type: Input
            }], bulleAideAlt: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], mapMessagesErreur: [{
                type: Input
            }], dataChange: [{
                type: Output
            }] } });

class CcdErreurTechniqueComponent {
    constructor() { }
    ngOnInit() {
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdErreurTechniqueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdErreurTechniqueComponent, selector: "ccd-erreur-technique", ngImport: i0, template: "<div class=\"row\">\r\n    <div class=\"col-sm-5 center-middle-block\">\r\n        <div class=\"alert alert-danger\" role=\"alert\" style=\"margin-top:10px\">\r\n            <span class=\"glyphicon glyphicon-alert\" aria-hidden=\"true\"></span>\r\n            Un incident technique s'est produit.\r\n            <br/>\r\n            Merci de renouveler votre d\u00E9marche.\r\n        </div>\r\n    </div>\r\n</div>", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdErreurTechniqueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-erreur-technique', template: "<div class=\"row\">\r\n    <div class=\"col-sm-5 center-middle-block\">\r\n        <div class=\"alert alert-danger\" role=\"alert\" style=\"margin-top:10px\">\r\n            <span class=\"glyphicon glyphicon-alert\" aria-hidden=\"true\"></span>\r\n            Un incident technique s'est produit.\r\n            <br/>\r\n            Merci de renouveler votre d\u00E9marche.\r\n        </div>\r\n    </div>\r\n</div>" }]
        }], ctorParameters: () => [] });

class CcdLocaliteModel {
    correspondance = "";
    codePostal = "";
    commune = "";
    cleGeo = "";
    cleGeoAgg = "";
    codeInsee = "";
    codePostalCommune = "";
}
class CcdLocaliteModelList {
    total_count;
    incomplete_results;
    localiteList;
}

class CcdStringUtils {
    static stringToNumber(val) {
        let res;
        if (val) {
            res = +val;
        }
        return res;
    }
    static numberToString(num) {
        let res;
        if (num) {
            res = num.toString();
        }
        return res;
    }
    /**
     * Conversion string --> boolean
     * @param stringVal
     */
    static stringToBoolean(stringVal) {
        let result = false;
        if (stringVal == "true" || stringVal == "false") {
            result = (stringVal == "true");
        }
        return result;
    }
    /**
     * Indique si une string peut être interprétée en boolean
     * @param stringVal
     */
    static isStringBoolean(stringVal) {
        return (stringVal == "true" || stringVal == "false");
    }
}

class CcdCodePostalService {
    http;
    env;
    // Recherche code postal commune
    AMABIS_LOCALITES_URL = '/api/absamabismiddle/v1/localites';
    constructor(http, env) {
        this.http = http;
        this.env = env;
    }
    /**
     * Data renvoyée en mode bouchon
     */
    buildStub() {
        const stubResult = new CcdLocaliteModelList();
        stubResult.localiteList = [
            {
                "correspondance": "100%",
                "codePostal": "77420",
                "commune": "CHAMPS SUR MARNE",
                "cleGeo": "452170",
                "cleGeoAgg": "452170",
                "codeInsee": "77083",
                "codePostalCommune": "77420 CHAMPS SUR MARNE"
            },
            {
                "correspondance": "70%",
                "codePostal": "77421",
                "commune": "MARNE LA VALLEE CEDEX 2",
                "cleGeo": "452170",
                "cleGeoAgg": "452170",
                "codeInsee": "77083",
                "codePostalCommune": "77421 MARNE LA VALLEE CEDEX 2;CHAMPS SUR MARNE"
            }
        ];
        return stubResult;
    }
    /**
     * Récupération des localités possibles en fonction du code postal et / ou de la commune
     * @param codePostalCommune Code postal et / ou commune
     */
    getLocalites(codePostalCommune) {
        let loc;
        if (this.env?.bouchon) {
            loc = of(this.buildStub());
        }
        else {
            loc = this.http.get(this.AMABIS_LOCALITES_URL, { params: { code_postal_commune: codePostalCommune } });
        }
        return loc;
    }
    /**
     * renvoie vrai si le code postal n'est pas dans la liste des intervalles à exclure.
     * Les intervalles sont de type [min, max]
     * @param codePostal number
     * @param listeExclusion Array<IntervalleModel>
     */
    isCodePostalAutorise(codePostal, listeExclusion) {
        let result = true;
        if (codePostal != undefined && codePostal != null && listeExclusion != undefined) {
            listeExclusion.forEach(value => {
                result = result && ((codePostal < value.min) || (codePostal > value.max));
            });
        }
        return result;
    }
    /**
     * renvoie vrai si le code postal n'est pas dans la liste des intervalles à exclure.
     * Les intervalles sont de type [min, max]
     * @param localite CcdLocaliteModelList
     * @param listeExclusion Array<CcdIntervalleModel>
     */
    isLocaliteeAutorisee(localite, listeExlusion) {
        const codePostal = CcdStringUtils.stringToNumber(localite?.codePostal);
        return this.isCodePostalAutorise(codePostal, listeExlusion);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdCodePostalService, deps: [{ token: i1$1.HttpClient }, { token: 'environment' }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdCodePostalService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdCodePostalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['environment']
                }] }] });

class CcdCodePostalCommuneComponent {
    cd;
    controlContainer;
    codePostalService;
    /**
     * Nom utilisé dans le formControl et 'ID html du composant
     */
    name = "";
    /**
     * Form control associé au composant
     */
    codePostalForm = new FormControl('', []);
    /**
     * Valeur renvoyée par le composant
     */
    _valeur;
    set valeur(valeur) {
        this._valeur = valeur;
    }
    get valeur() {
        return this._valeur;
    }
    /**
     * Attribut utilisé pour mettre en lecture seule
     */
    _disabled = false;
    set disabled(isDisabled) {
        this._disabled = isDisabled;
        this.updateDisabled();
    }
    dataChange = new EventEmitter();
    listeExclusion;
    localiteNonEligible = new EventEmitter();
    onHttpError = new EventEmitter();
    suggestions$;
    suggestions = new Array();
    // Subscribers
    subscribers = new Array();
    minLength = 5;
    /**
     * Constructeur du composant
     * @param controlContainer  ControlContainer
     */
    constructor(cd, controlContainer, codePostalService) {
        this.cd = cd;
        this.controlContainer = controlContainer;
        this.codePostalService = codePostalService;
        this._valeur = new CcdLocaliteModel();
        this.listeExclusion = new Array();
    }
    /**
     * Initialisation du composant
     */
    ngOnInit() {
        const parentForm = this.controlContainer?.control;
        this.codePostalForm = new FormControl(this._valeur.codePostalCommune, [Validators.required, this.validationCodePostalNonSelectione(), this.validationCodePostalAutorise()]);
        parentForm.addControl(this.name, this.codePostalForm);
        this.updateDisabled();
        // Recherche du code postal commune
        this.suggestions$ = new Observable((observer) => {
            observer.next(this.codePostalForm.value);
        }).pipe(switchMap((query) => {
            if (query) {
                const localites = this.codePostalService.getLocalites(query);
                return localites.pipe(map((data) => data && data.localiteList || []), tap({
                    next: (val) => {
                        this.suggestions = val;
                    },
                    error: (err) => {
                        this.onHttpError.emit(err);
                    }
                }));
            }
            return of([]);
        }));
        this.subscribers.push(this.codePostalForm.valueChanges.subscribe(data => {
            if (this.suggestions != undefined && this.suggestions.length > 0) {
                let selection = this.selectionnerLocalite(this.suggestions);
                if (selection?.codePostalCommune !== this._valeur?.codePostalCommune) {
                    this._valeur = selection;
                    this.codePostalForm.updateValueAndValidity({ onlySelf: true, emitEvent: false });
                    this.dataChange.emit(this._valeur);
                }
            }
        }));
        this.subscribers.push(this.codePostalForm.statusChanges.subscribe(status => {
            if (this.codePostalForm?.errors?.codePostalNonAutorise) {
                this.localiteNonEligible.emit(true);
            }
        }));
    }
    ngAfterContentChecked() {
        this.cd.detectChanges();
    }
    /**
     * A la destruction du composant :
     * Suppression des listeners
     * Suppression du FormControl dans le parent pour eviter des erreurs de validation
     * Emmit de la valeur à vide (pour que le parent ne garde pas l'ancienne valeur)
     */
    ngOnDestroy() {
        const parentForm = this.controlContainer.control;
        parentForm.removeControl(this.name);
        this.subscribers.forEach(sub => sub.unsubscribe());
        this.dataChange.emit(undefined);
    }
    /**
     * Mise en lecture seule ou pas selon la valeur de l'attribut "disabled"
     */
    updateDisabled() {
        if (this._disabled) {
            this.codePostalForm.disable();
        }
        else {
            this.codePostalForm.enable();
        }
    }
    selectionnerLocalite(localites) {
        let result = new CcdLocaliteModel();
        if (localites != null && localites != undefined && localites.length > 0) {
            localites.find(x => {
                (x.codePostalCommune === this.codePostalForm.value) ? result = x : false;
            });
        }
        return result;
    }
    validationCodePostalNonSelectione() {
        return () => {
            let codePostalSelectionne = (this._valeur?.codePostalCommune == this.codePostalForm.value);
            return !codePostalSelectionne ? { codePostalNonSelectionne: true } : null;
        };
    }
    validationCodePostalAutorise() {
        return () => {
            const codePostalAutorise = this.codePostalService.isLocaliteeAutorisee(this._valeur, this.listeExclusion);
            return !codePostalAutorise ? { codePostalNonAutorise: true } : null;
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdCodePostalCommuneComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.ControlContainer }, { token: CcdCodePostalService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdCodePostalCommuneComponent, selector: "ccd-code-postal-commune", inputs: { name: "name", valeur: "valeur", disabled: "disabled", listeExclusion: "listeExclusion" }, outputs: { dataChange: "dataChange", localiteNonEligible: "localiteNonEligible", onHttpError: "onHttpError" }, ngImport: i0, template: "<!-- CODE POSTAL -->\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12 col-sm-6 col-md-4\">\r\n        <label class=\"label-form-cnaf control-label\" for=\"{{name}}\">Code postal du logement concern\u00E9</label>\r\n        <div class=\"form-group\" \r\n            [ngClass]=\"{'has-error':(!codePostalForm.valid) && codePostalForm.touched}\">\r\n            <input \r\n                id=\"{{name}}\" \r\n                [formControl]=\"codePostalForm\" \r\n                type=\"text\" \r\n                class=\"form-control\" \r\n                typeaheadOptionField=\"codePostalCommune\"\r\n                [typeahead]=\"suggestions$\"\r\n                [typeaheadAsync]=\"true\"\r\n                [typeaheadMinLength]=\"minLength\"\r\n                placeholder=\"Ex: 75000\"\r\n            />\r\n        </div>\r\n    </div>\r\n</div>\r\n<div role=\"alert\" *ngIf=\"codePostalForm.errors && codePostalForm.touched\" class=\"help-block\">\r\n    <p *ngIf=\"codePostalForm.errors.required\" class=\"text-danger\">Champ obligatoire</p>\r\n    <p *ngIf=\"codePostalForm.errors.codePostalNonSelectionne && !codePostalForm.errors.required\" class=\"text-danger\">Adresse inconnue</p>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgCnafMessageErreurDirective, selector: "[formControlName],[formControl]", inputs: ["ngCnafMessageErreur", "controlName", "showError"] }, { kind: "directive", type: i5.TypeaheadDirective, selector: "[typeahead]", inputs: ["typeahead", "typeaheadMinLength", "adaptivePosition", "isAnimated", "typeaheadWaitMs", "typeaheadOptionsLimit", "typeaheadOptionField", "typeaheadGroupField", "typeaheadOrderBy", "typeaheadAsync", "typeaheadLatinize", "typeaheadSingleWords", "typeaheadWordDelimiters", "typeaheadMultipleSearch", "typeaheadMultipleSearchDelimiters", "typeaheadPhraseDelimiters", "typeaheadItemTemplate", "optionsListTemplate", "typeaheadScrollable", "typeaheadOptionsInScrollableView", "typeaheadHideResultsOnBlur", "typeaheadSelectFirstItem", "typeaheadIsFirstItemActive", "container", "dropup"], outputs: ["typeaheadLoading", "typeaheadNoResults", "typeaheadOnSelect", "typeaheadOnPreview", "typeaheadOnBlur"], exportAs: ["bs-typeahead"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdCodePostalCommuneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-code-postal-commune', template: "<!-- CODE POSTAL -->\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12 col-sm-6 col-md-4\">\r\n        <label class=\"label-form-cnaf control-label\" for=\"{{name}}\">Code postal du logement concern\u00E9</label>\r\n        <div class=\"form-group\" \r\n            [ngClass]=\"{'has-error':(!codePostalForm.valid) && codePostalForm.touched}\">\r\n            <input \r\n                id=\"{{name}}\" \r\n                [formControl]=\"codePostalForm\" \r\n                type=\"text\" \r\n                class=\"form-control\" \r\n                typeaheadOptionField=\"codePostalCommune\"\r\n                [typeahead]=\"suggestions$\"\r\n                [typeaheadAsync]=\"true\"\r\n                [typeaheadMinLength]=\"minLength\"\r\n                placeholder=\"Ex: 75000\"\r\n            />\r\n        </div>\r\n    </div>\r\n</div>\r\n<div role=\"alert\" *ngIf=\"codePostalForm.errors && codePostalForm.touched\" class=\"help-block\">\r\n    <p *ngIf=\"codePostalForm.errors.required\" class=\"text-danger\">Champ obligatoire</p>\r\n    <p *ngIf=\"codePostalForm.errors.codePostalNonSelectionne && !codePostalForm.errors.required\" class=\"text-danger\">Adresse inconnue</p>\r\n</div>" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i1.ControlContainer }, { type: CcdCodePostalService }], propDecorators: { name: [{
                type: Input
            }], valeur: [{
                type: Input
            }], disabled: [{
                type: Input
            }], dataChange: [{
                type: Output
            }], listeExclusion: [{
                type: Input
            }], localiteNonEligible: [{
                type: Output
            }], onHttpError: [{
                type: Output
            }] } });

class CcdRubriqueMontantModel {
    isActive = false;
    montant = '';
    erreurs = [];
}

class CcdRubriqueMontantComponent {
    controlContainer;
    cd;
    name = "";
    id = "";
    montantId = "";
    libelle = "";
    montantPlaceHolder = "";
    montantValidators = new Array();
    montantMapErreurs = new Map();
    _disabled = false;
    set disabled(isDisabled) {
        this._disabled = isDisabled;
        this.updateDisabledInForm();
    }
    get disabled() {
        return this._disabled;
    }
    _rubriqueModel = new CcdRubriqueMontantModel();
    set rubriqueModel(rubData) {
        this._rubriqueModel = rubData;
        this.modelToFormData();
    }
    get rubriqueModel() {
        return this._rubriqueModel;
    }
    dataChange = new EventEmitter();
    rubriqueForm = new FormGroup({
        actif: new FormControl(this._rubriqueModel.isActive, { nonNullable: true })
    });
    subscriber;
    constructor(controlContainer, cd) {
        this.controlContainer = controlContainer;
        this.cd = cd;
    }
    /**
     * Récupération du formGroup parent
     * Initialisation du formGroup de la rubrique, du formControl de la checkBox
     * Ajout dynamique du formGroup de la rubrique dans le parent (celui-ci pourra ainsi récupérer dynamiquement le statut du formulaire)
     *
     * Chargement des données provenant du rubriqueModel dans les objets de type Form
     *
     * Création d'un Listener sur les modifications du formGroup pour mettre à jour RubriqueModel
     * La fonction listener écrase la donnée rubriqueModel pour effectuer le binding en sortie (exploité directement par le parent)
     */
    ngOnInit() {
        if (this.id === '') {
            this.id = this.name;
        }
        const parentForm = this.controlContainer?.control;
        this.rubriqueForm = new FormGroup({
            actif: new FormControl(this._rubriqueModel.isActive, { nonNullable: true })
        });
        // this.rubriqueForm.addControl(this.name+"_checkbox", this.checkboxFormControl);
        parentForm.addControl(this.name, this.rubriqueForm);
        this.updateDisabledInForm();
        this.modelToFormData();
        this.subscriber = this.rubriqueForm.valueChanges.subscribe(data => {
            this.formDataToModel();
            this.dataChange.emit(this._rubriqueModel);
        });
    }
    ngAfterContentChecked() {
        this.cd.detectChanges();
    }
    /**
     * Suppression dynamique des elements du composant dans le parent.
     * Pour éviter que les validators remontent encore des erreurs alors que les elements sont supprimés du DOM
     *
     * Destruction du listener créé dans l'init
     */
    ngOnDestroy() {
        const parentForm = this.controlContainer.control;
        parentForm.removeControl(this.name);
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    }
    /**
     * Met a jour le statut disable du formulaire en fonction du parametre input disabled
     */
    updateDisabledInForm() {
        if (this._disabled) {
            this.rubriqueForm.controls.actif.disable();
        }
        else {
            this.rubriqueForm.controls.actif.enable();
        }
    }
    /**
     * Chargement des données du formulaire dans rubriqueModel
     */
    formDataToModel() {
        this._rubriqueModel.isActive = this.rubriqueForm.controls.actif.value;
        if (this.rubriqueForm.getRawValue().montant) {
            this._rubriqueModel.montant = this.rubriqueForm.getRawValue().montant;
        }
        else {
            this._rubriqueModel.montant = '';
        }
        this._rubriqueModel.erreurs = [];
        if (this.rubriqueForm?.controls.montant?.errors != null) {
            this._rubriqueModel.erreurs = Object.keys(this.rubriqueForm.controls.montant.errors);
        }
    }
    /**
     * Chargement des données de rubriqueModel dans le formulaire
     */
    modelToFormData() {
        this.rubriqueForm.controls.actif.patchValue(this._rubriqueModel.isActive);
        this.rubriqueForm.controls.montant?.patchValue(this._rubriqueModel.montant);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdRubriqueMontantComponent, deps: [{ token: i1.ControlContainer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdRubriqueMontantComponent, selector: "ccd-rubrique-montant", inputs: { name: "name", id: "id", montantId: "montantId", libelle: "libelle", montantPlaceHolder: "montantPlaceHolder", montantValidators: "montantValidators", montantMapErreurs: "montantMapErreurs", disabled: "disabled", rubriqueModel: "rubriqueModel" }, outputs: { dataChange: "dataChange" }, ngImport: i0, template: "<div [formGroup]=\"rubriqueForm\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n            <!-- Champ Ckeckbox -->\r\n            <label class=\"label-form-cnaf align-middle-cnaf\" for=\"{{id}}_checkbox\">\r\n                <ng-cnaf-checkbox \r\n                    [formControl]=\"rubriqueForm.controls.actif\" \r\n                    name=\"{{id}}_checkbox\" \r\n                    aria-labelledby=\"{{id}}_libelle\">\r\n                </ng-cnaf-checkbox>\r\n                <span id=\"{{id}}_libelle\">{{libelle}}</span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" *ngIf=\"rubriqueForm.controls.actif.value\">\r\n        <div class=\"col-sm-12\">\r\n            <ccd-montant \r\n                name=\"montant\" \r\n                id=\"{{montantId}}\"\r\n                [value]=\"rubriqueModel.montant\"\r\n                [disabled]=\"disabled\"\r\n                [placeHolder]=\"montantPlaceHolder\"\r\n                [validators]=\"montantValidators\"\r\n                [mapMessagesErreur]=\"montantMapErreurs\">\r\n            </ccd-montant>\r\n        </div>\r\n    </div>    \r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.NgCnafCheckboxComponent, selector: "ng-cnaf-checkbox", inputs: ["name", "aria-labelledby"] }, { kind: "directive", type: i3.NgCnafMessageErreurDirective, selector: "[formControlName],[formControl]", inputs: ["ngCnafMessageErreur", "controlName", "showError"] }, { kind: "component", type: CcdMontantComponent, selector: "ccd-montant", inputs: ["name", "id", "libelle", "value", "placeHolder", "validators", "disabled", "bulleAideDivId", "bulleAideAlt", "maxlength", "mapMessagesErreur"], outputs: ["dataChange"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdRubriqueMontantComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-rubrique-montant', template: "<div [formGroup]=\"rubriqueForm\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n            <!-- Champ Ckeckbox -->\r\n            <label class=\"label-form-cnaf align-middle-cnaf\" for=\"{{id}}_checkbox\">\r\n                <ng-cnaf-checkbox \r\n                    [formControl]=\"rubriqueForm.controls.actif\" \r\n                    name=\"{{id}}_checkbox\" \r\n                    aria-labelledby=\"{{id}}_libelle\">\r\n                </ng-cnaf-checkbox>\r\n                <span id=\"{{id}}_libelle\">{{libelle}}</span>\r\n            </label>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" *ngIf=\"rubriqueForm.controls.actif.value\">\r\n        <div class=\"col-sm-12\">\r\n            <ccd-montant \r\n                name=\"montant\" \r\n                id=\"{{montantId}}\"\r\n                [value]=\"rubriqueModel.montant\"\r\n                [disabled]=\"disabled\"\r\n                [placeHolder]=\"montantPlaceHolder\"\r\n                [validators]=\"montantValidators\"\r\n                [mapMessagesErreur]=\"montantMapErreurs\">\r\n            </ccd-montant>\r\n        </div>\r\n    </div>    \r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1.ControlContainer }, { type: i0.ChangeDetectorRef }], propDecorators: { name: [{
                type: Input
            }], id: [{
                type: Input
            }], montantId: [{
                type: Input
            }], libelle: [{
                type: Input
            }], montantPlaceHolder: [{
                type: Input
            }], montantValidators: [{
                type: Input
            }], montantMapErreurs: [{
                type: Input
            }], disabled: [{
                type: Input
            }], rubriqueModel: [{
                type: Input
            }], dataChange: [{
                type: Output
            }] } });

class CcdBarreNavigationComponent {
    ccdBarreNavigationService;
    /**
     * Liste des libelles à passer à la barre d'etapes
     */
    steps;
    /**
     * Observable sur l'etape à selectionner (modifié à partir du service)
     */
    stepActive$;
    /**
     * Tableau des subscribers utilisé par le composant
     */
    subscribers;
    /**
     * Etape a selectionner en fonction de l'observable stepActive$
     */
    stepActive;
    /**
     * Espacement en pourcentage entre la barre d'étape et la le bord droit du conteneur de la barre
     */
    widthInvisible;
    /**
     * Affichage si les steps sont définis
     */
    affiche;
    /**
     *
     * @param ccdBarreNavigationService
     */
    constructor(ccdBarreNavigationService) {
        this.ccdBarreNavigationService = ccdBarreNavigationService;
        this.steps = [];
        this.stepActive$ = of("");
        this.stepActive = "";
        this.affiche = false;
        this.widthInvisible = '35%';
        this.subscribers = new Array();
    }
    /**
     * Récupration des propriétés de la barre d'étape à partir du service de la barre de navigation
     */
    ngOnInit() {
        this.steps = this.ccdBarreNavigationService.getLibellesEtapes();
        this.affiche = (this.steps !== undefined && this.steps !== null && this.steps.length > 0);
        this.stepActive$ = this.ccdBarreNavigationService.getLibelleEtapeCourante$();
        this.subscribers.push(this.stepActive$.subscribe((newVal) => this.stepActive = newVal));
    }
    /**
     * Destruction des subscribers
     */
    ngOnDestroy() {
        this.subscribers.forEach((subscriber) => subscriber.unsubscribe());
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreNavigationComponent, deps: [{ token: CcdBarreNavigationService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: CcdBarreNavigationComponent, selector: "ccd-barre-navigation", inputs: { widthInvisible: "widthInvisible" }, ngImport: i0, template: "<div class=\"col-sm-12 center-middle-block\">\r\n    <div *ngIf=\"affiche\" class=\"affix-top\" id=\"barre-etape-teleprocedure-cnaf\">\r\n        <ng-cnaf-barre-etape [stepActive]=\"stepActive\" [steps]=\"steps\" [widthInvisible]=\"widthInvisible\"></ng-cnaf-barre-etape>\r\n    </div>\r\n<div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.NgCnafBarreEtapeComponent, selector: "ng-cnaf-barre-etape", inputs: ["steps", "stepActive", "widthInvisible"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CcdBarreNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ccd-barre-navigation', template: "<div class=\"col-sm-12 center-middle-block\">\r\n    <div *ngIf=\"affiche\" class=\"affix-top\" id=\"barre-etape-teleprocedure-cnaf\">\r\n        <ng-cnaf-barre-etape [stepActive]=\"stepActive\" [steps]=\"steps\" [widthInvisible]=\"widthInvisible\"></ng-cnaf-barre-etape>\r\n    </div>\r\n<div>\r\n" }]
        }], ctorParameters: () => [{ type: CcdBarreNavigationService }], propDecorators: { widthInvisible: [{
                type: Input
            }] } });

class CnafCommonsDralModule {
    static forRoot(environment) {
        return {
            ngModule: CnafCommonsDralModule,
            providers: [
                { provide: 'environment', useValue: environment }
            ]
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralModule, declarations: [CnafCommonsDralComponent,
            CcdBoutonsRadioComponent,
            CcdBarreProgressionComponent,
            CcdMontantComponent,
            CcdErreurTechniqueComponent,
            CcdCodePostalCommuneComponent,
            CcdRubriqueMontantComponent,
            CcdBarreNavigationComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgCnafCommonsModule,
            HttpClientModule,
            TypeaheadModule], exports: [CnafCommonsDralComponent,
            CcdBoutonsRadioComponent,
            CcdBarreProgressionComponent,
            CcdMontantComponent,
            CcdErreurTechniqueComponent,
            CcdCodePostalCommuneComponent,
            CcdRubriqueMontantComponent,
            CcdBarreNavigationComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralModule, imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgCnafCommonsModule,
            HttpClientModule,
            TypeaheadModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CnafCommonsDralModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnafCommonsDralComponent,
                        CcdBoutonsRadioComponent,
                        CcdBarreProgressionComponent,
                        CcdMontantComponent,
                        CcdErreurTechniqueComponent,
                        CcdCodePostalCommuneComponent,
                        CcdRubriqueMontantComponent,
                        CcdBarreNavigationComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        NgCnafCommonsModule,
                        HttpClientModule,
                        TypeaheadModule
                    ],
                    exports: [
                        CnafCommonsDralComponent,
                        CcdBoutonsRadioComponent,
                        CcdBarreProgressionComponent,
                        CcdMontantComponent,
                        CcdErreurTechniqueComponent,
                        CcdCodePostalCommuneComponent,
                        CcdRubriqueMontantComponent,
                        CcdBarreNavigationComponent
                    ]
                }]
        }] });

class CcdIntervalleModel {
    min;
    max;
    constructor(min, max) {
        this.min = min;
        this.max = max;
    }
}

class CcdBoutonModel {
    // TODO : Enlever "?" après libelle
    libelle;
    code;
}

/*
 * Public API Surface of cnaf-commons-dral
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CcdBarreNavigationComponent, CcdBarreNavigationService, CcdBarreProgressionComponent, CcdBoutonModel, CcdBoutonsRadioComponent, CcdCodePostalCommuneComponent, CcdErreurTechniqueComponent, CcdIntervalleModel, CcdLocaliteModel, CcdLocaliteModelList, CcdMontantComponent, CcdRubriqueMontantComponent, CcdRubriqueMontantModel, CnafCommonsDralComponent, CnafCommonsDralModule, MontantForm };
